import React, { Component, Fragment } from 'react';
import { do_action } from '../../actions';
import {BASE_URL_ADMIN} from '../../data/config'
import _ from 'lodash'

class ModalAddItemQuote extends Component {
    constructor(props) {
        super(props)
        this.state = {
            price: 0,
            quantity: 1,
            itemSelect: '',
            allItems: [],
            group_id: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.nb_add != this.props.nb_add) {
            let {roomAdd, vendor, house_type} = nextProps
            if (roomAdd.items) {
                let {items} = roomAdd
                let existItems = items.map(it => {
                    return it.item_id || it.items._id
                })

                let group_id = items[0] ? items[0].group_id : vendor.group_id

                do_action('get_items_vendor_group', {group_id, vendor_id: vendor._id, house_type})
                .then(response => {
                    if (response.signal) {
                        let {allItems, itemVendor} = response.data
                        let dataPrice = {}
                        itemVendor.map(it => {
                            dataPrice[it.item_id] = it.price
                        })
                        allItems = allItems.filter(its => {
                            return existItems.indexOf(its._id) < 0
                        }).map(it => {
                            if (dataPrice[it._id]) {
                                it.price = dataPrice[it._id]
                            }

                            return it
                        })

                        let itemSelect = allItems.length ? allItems[0] : ''

                        this.setState({
                            allItems,
                            itemSelect,
                            price: itemSelect ? itemSelect.price : 0,
                            group_id
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
        }
    }

    handleChange(key, e) {
        this.setState({
            [key]: e.target.value
        })
    }

    handleSelectItem(e) {
        let {allItems} = this.state
        let id = e.target.value
        let it = _.find(allItems, (o) => {
            return o._id == id
        })

        if (it) {
            this.setState({
                itemSelect: it,
                price: it.price
            })
        }
    }

    renderSelectItems() {
        let {itemSelect, allItems} = this.state
        let content = allItems.map((it, idx) => {
            return (
                <option value={it._id} key={idx}>{it.title}</option>
            )
        })

        return (
            <select className="form-control form-control-mix" value={itemSelect ? itemSelect._id : ''} onChange={this.handleSelectItem.bind(this)} >
                {content}
            </select>
        )
    }

    submitAddItem(e) {
        e.preventDefault()
        let {vendor, total_price, roomAdd} = this.props;
        let {price, itemSelect, quantity, group_id} = this.state;
        if (!price || !quantity || !itemSelect)
            return alert('Please enter all input')

        let priceNb = parseFloat(price)
        quantity = parseFloat(quantity)
        if (priceNb < 0)
            return alert('Please enter valid number price')
        if (quantity < 0)
            return alert('Please enter valid number quantity')

        do_action('add_item_quote_vendor', { vendor_id: vendor._id, price: priceNb, items: itemSelect, quantity, quote_id: roomAdd.room.quotes, room_id: roomAdd.room._id })
            .then(data => {
                if (data.signal) {
                    let price_item = priceNb * quantity
                    price_item = parseFloat(price_item)
                    total_price = parseFloat(total_price)
                    let new_total_price = total_price + price_item
                    new_total_price = new_total_price.toFixed(2)
                    let $ = window.$;
                    $('#modal-add-item-quotes').modal('hide');
                    itemSelect.price = price
                    let {items} = roomAdd

                    let itemData = Object.assign({}, items[0])
                    itemData = Object.assign(itemData, {
                        items: itemSelect,
                        price_unit: {price, type_item: 2},
                        quantity,
                        quantity_area: `${quantity} ${itemSelect.type_price}`,
                        total_price: price_item.toFixed(2),
                        type_value: '',
                        dm: {
                            quantity,
                            value: 1,
                            type: itemSelect.type_price,
                            dm: `${quantity} ${itemSelect.type_price}`
                        },
                        value: '',
                        url: itemSelect.image_path ? BASE_URL_ADMIN + '/uploads/' + itemSelect.image_path : '/images/re1.png'
                    })

                    items.push(itemData)
                    roomAdd.items = items

                    this.props.addItems({roomAdd, new_total_price});
                    this.setState({
                        quantity: 1
                    })
                }
            })
            .catch(err => console.log(err));
            
    }

    render() {
        let {roomAdd} = this.props
        let {price, itemSelect, quantity} = this.state
        return (
            <div className="modal fade" id="modal-add-item-quotes" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">

                    <div className="modal-ruhu">
                        <div className="mdr-title">
                            <div className="text">Add Items</div>
                            <a href="#" data-dismiss="modal" className="closeX">
                                <img src="/images/icon-close.png" alt=""/>
                            </a>
                        </div>
                            <div className="mdr-content">
                                {roomAdd && (
                                    <Fragment>
                                        <p className="fontMedium tit">Room</p>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-mix" value={roomAdd.room.rooms.name} readOnly={true} />
                                        </div>
                                        <p className="fontMedium tit">Select Items</p>
                                        <div className="form-group">
                                            {this.renderSelectItems()}
                                        </div>
                                        <p className="fontMedium tit">{`Quantity (${itemSelect.type_price})`}</p>
                                        <div className="form-group">
                                            <input type="number" className="form-control form-control-mix" placeholder="Enter price..." value={quantity} onChange={this.handleChange.bind(this, 'quantity')} />
                                        </div>
                                    </Fragment>
                                )}
                                
                                <p className="fontMedium tit">Price</p>
                                <div className="form-group">
                                    <input type="number" className="form-control form-control-mix" placeholder="Enter price..." value={price} onChange={this.handleChange.bind(this, 'price')} />
                                </div>
                                <div className="form-group">
                                    <a href="#" className="bg-blue btn-block text-center btn-blue" onClick={this.submitAddItem.bind(this)}>Add Item</a>
                                </div>
                            </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default ModalAddItemQuote;